<template>
  <div class="about">
    <!-- <div class="about_w"> -->
    <div class="about1">
      <div class="about_tit">
        DO Network is a <br />decentralized<br />
        network with<br />
        ultra-high<br />
        performance.
      </div>
      <div class="about_tit1">
        It has achieved a scalable DPOS consensus <br />agreement through a
        number of technological<br />
        innovations,which we call Wave Consensus,so as <br />to achieve more
        unimaginable TPS performance.
      </div>
    </div>
    <div class="about2">
      <!-- <div class="tit">Key features</div> -->
      <div class="con">
        <div class="aboutbox">
          <img src="../../assets/m/about/1.png" class="img1" />
          <div class="tit1">Ultra-high Performance</div>
          <div class="tit2">
            Block time less than 0.1 second, TPS more<br />
            than 1000
          </div>
        </div>
        <div class="aboutbox">
          <img src="../../assets/m/about/2.png" class="img2" />
          <div class="tit1">Extreme Low Gas</div>
          <div class="tit2">
            Use 1 dollar to complete more than 10,000 <br />transactions
          </div>
        </div>
        <div class="aboutbox">
          <img src="../../assets/m/about/3.png" class="img3" />
          <div class="tit1">Easy Access To Join</div>
          <div class="tit2">
            20,000 DO to run a node, 1,500 DO to stake and<br />
            win APY
          </div>
        </div>
        <div class="aboutbox">
          <img src="../../assets/m/about/4.png" class="img4" />
          <div class="tit1">Innovative Technology</div>
          <div class="tit2">
            Wave value consensus with EVM-equivalent<br />
            compatibility
          </div>
        </div>
      </div>
    </div>
    <div class="about3">
      <div class="tit">Why “DO” matters?</div>
      <div class="con">
        DO Network is the most decentralized network<br />
        for Web3 citizens to join, build and run. We <br />devote ourselves to
        building a low-threshold<br />
        network for every DO builder, so that each<br />
        attendant doesn’t need to satisfy<br />
        complicated verification to join the network.<br />
        You are easy and welcome to play an<br />
        important role with easy access.
      </div>
    </div>
    <div class="about4">
      <div class="tit">How does DO differ from other Layer 1?</div>
      <div class="con">
        DO network focus on the most basic and most<br />
        critical factors for a Layer 1 blockchain.
      </div>
      <div class="aboutbox">
        <div class="boxli">
          <img src="../../../src/assets/m/about/5.png" class="img5"/>
          <div class="litit">Performance</div>
          <div class="licon">
            Performance is the key feature for a Layer to<br />
            get mass adoption. Some Layer 1 blockchain<br />
            have a good TPS, however, when a huge<br />
            traffic occurs, the performance will become<br />
            worse. Do network offers users a stable and<br />
            smooth experience whenever users visit,<br />
            based on our unique “Wave Consensus”.
          </div>
        </div>
        <div class="boxli">
          <img src="../../../src/assets/m/about/6.png" class="img6" />
          <div class="litit">Decentralization</div>
          <div class="licon">
            Decentralization is the basic feature of<br />
            blockchain, however, not all blockchains<br />
            really make it true. Web3 builders can find<br />
            that there are huge barriers to stop them <br />from being nodes and
            participate in building<br />
            the blockchain network. Do network makes it <br />easy for builders
            to join in the network and<br />
            become part of it, and governance right is<br />
            back to the people.
          </div>
        </div>
        <div class="boxli">
          <img src="../../../src/assets/m/about/7.png" class="img7" />
          <div class="litit">Community</div>
          <div class="licon">
            No blockchain system can develop without<br />
            community. Do network has built<br />
            a strong community of over 100,000 <br />members from all over the
            world and<br />
            each member is part of the network,<br />
            keeping building and protecting it.
          </div>
        </div>
      </div>
    </div>
    <div class="about5">
      <div class="aboutbox">
        <div class="tit">What is Wave Consensus?</div>
        <div class="tit1">
          The wave protocol of Do network is a special<br />
          consensus algorithm, which is driven by local<br />
          consensus to reach an agreement across the<br />
          network, just like the wave driving gradually<br />
          covers the entire sea area, so we call it the<br />
          wave consensus protocol.
        </div>
        <div class="box">
          <div class="right">
            <div class="left"></div>
            <div class="rtit">
              The goal of the wave consensus<br />
              protocol
            </div>
          </div>
          <div class="rcon">
            We hope that the consensus process is<br />
            safe, simple and efficient, which is <br />designed to improve the
            overall<br />
            performance of the network.
          </div>
        </div>
        <div class="box box1">
          <div class="right">
            <div class="left left1"></div>
            <div class="rtit">
              Algorithm of the wave consensus <br />protocol
            </div>
          </div>
          <div class="rcon">
            The generated random number and the <br />time axis combine to form
            a smooth and <br />unpredictable trajectory by adopting the<br />
            dual VRF random algorithm. Do Network<br />
            will elect a candidate from the legal<br />
            verification nodes of the whole network.<br />
            The consensus of 2/3 nodes of the whole<br />
            network can be completed only after the<br />
            candidate and verifiers of different<br />
            groups reach an agreement on the<br />transaction.
          </div>
        </div>
      </div>
    </div>
    <div class="about6">
      <div class="aboutl">
        <div class="tit">
          How is the DO network<br />
          developing?
        </div>
        <img src="../../../src/assets/m/about/8.png" class="img8" />
        <div class="tit1">
          Since the DO mainnet launched in 2021,<br />
          the DO network has been running stably<br />
          for more than 3 years.
        </div>
        <div class="tit2">
          We have built more than 200 nodes around<br />
          the world, and a huge amount of applications<br />
          has been participated in the DO ecosystem,<br />
          including wallet, Defi, NFT, meme coins, AI, etc.
        </div>
      </div>
      <div class="aboutr">
        <img src="../../../src/assets/m/about/9.png" class="img9" />
        <div class="tit">
          We always regard ecosystem applications as<br />
          a key part of DO network and have always <br />been supporting our DO
          applications by<br />
          granting DO token, helping promote, holding<br />
          application competitions, technique<br />
          supporting, etc.
        </div>
      </div>
    </div>
    <div class="about7">
      <div class="line"></div>

      <div class="linkbox">
        <div class="tit">
          If you are a DO developer<br />
          with your DO application, <br />you can submit it
          <a @click="onhere">here</a> and <br />get various forms of<br />
          support from DO network.
        </div>
        <img src="../../../src/assets/m/about/10.png" />
      </div>
      <div class="line"></div>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    onhere(){
      this.$router.push('/m/GrantApplication')
    },
  },
};
</script>

<style lang="less" scoped>
.about {
  width: 750px;
  overflow: hidden;
  background: #fff;
  .about1 {
    width: 650px;
    margin: 0 auto;
    margin-top: 120px;
    .about_tit {
      font-family: Poppins, Poppins;
      font-weight: 900;
      font-size: 64px;
      color: #000000;
      line-height: 83px;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }
    .about_tit1 {
      font-family: Poppins, Poppins;
      font-weight: 500;
      font-size: 26px;
      color: #61666b;
      line-height: 43px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-top: 20px;
    }
  }
  .about2 {
    width: 650px;
    margin: 0 auto;
    padding-bottom: 140px;
    .tit {
      height: 34px;
      font-family: Poppins, Poppins;
      font-weight: 700;
      font-size: 24px;
      color: #000000;
      line-height: 34px;
      text-align: left;
      margin-top: 100px;
      margin-bottom: 20px;
    }
    .con {
      .aboutbox {
        margin-bottom: 60px;
        .img1 {
          width: 93px;
          height: 111px;
          margin-top: 127px;
          margin-left: 279px;
        }
        .img2 {
          width: 93px;
          height: 84px;
          margin-top: 52px;
          margin-left: 279px;
        }
        .img3 {
          width: 65px;
          height: 102px;
          margin-top: 58px;
          margin-left: 293px;
        }
        .img4 {
          margin-left: 278px;
          // margin-top: 140px;
          // margin-left: 134px;
          width: 93px;
          height: 89x;
        }
        .tit1 {
          height: 55px;
          font-family: Poppins, Poppins;
          font-weight: 600;
          font-size: 32px;
          color: #1a1a2c;
          line-height: 54px;
          text-align: center;
          font-style: normal;
          text-transform: none;
          margin-top: 36px;
          // margin-left: 60px;
        }
        .tit2 {
          font-family: Poppins, Poppins;
          font-weight: 500;
          font-size: 28px;
          color: #61666b;
          line-height: 46px;
          text-align: center;
          font-style: normal;
          text-transform: none;
          margin-top: 30px;
        }
      }
      .aboutbox:hover {
        width: 565px;
        height: 217px;
        background: rgba(255, 255, 255, 0.3);
        box-shadow: 0px 7px 35px 0px rgba(69, 115, 231, 0.2);
        border-radius: 15px 15px 15px 15px;
        border: 2px solid rgba(82, 124, 233, 0.2);
      }
    }
  }
  .about3 {
    background: url("../../assets/m/about/aboutb1.png") no-repeat;
    background-size: cover;
    height: 613px;
    padding-top: 80px;
    .tit {
      width: 750px;
      height: 55px;
      font-family: Poppins, Poppins;
      font-weight: 600;
      font-size: 32px;
      color: #1a1a2c;
      line-height: 54px;
      text-align: center;
      // padding-top: 80px;
    }
    .con {
      width: 750px;
      margin: 0 auto;
      font-family: Poppins, Poppins;
      font-weight: 500;
      font-size: 28px;
      color: #61666b;
      line-height: 46px;
      margin-top: 30px;
      text-align: center;
    }
  }
  .about4 {
    width: 750px;
    margin: 0 auto;
    padding-bottom: 140px;
    .tit {
      height: 55px;
      font-family: Poppins, Poppins;
      font-weight: 600;
      font-size: 32px;
      color: #1a1a2c;
      line-height: 54px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-top: 133px;
    }
    .con {
      font-family: Poppins, Poppins;
      font-weight: 500;
      font-size: 28px;
      color: #61666b;
      line-height: 46px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      text-align: center;
      margin-top: 30px;
    }
    .aboutbox {
      display: flex;
      flex-direction: column;
      .boxli {
        width: 650px;
        margin: 0 auto;
        margin-top: 60px;
        // img {
        //   width: 217px;
        //   height: 164px;
        //   margin-left: 211px;
        // }
        .img5{
          width: 211px;
          height: 169px;
          margin-left: 211px;
        }
        .img6{
          width: 175px;
          height: 168px;
          margin-left: 236px;
        }
        .img7{
          width: 207px;
          height: 207px;
          margin-left: 225px;
        }
        .litit {
          font-family: Poppins, Poppins;
          font-weight: 600;
          font-size: 32px;
          color: #1a1a2c;
          line-height: 54px;
          text-align: center;
          font-style: normal;
          text-transform: none;
          text-align: center;
        }
        .licon {
          font-family: Poppins, Poppins;
          font-weight: 500;
          font-size: 28px;
          color: #61666b;
          line-height: 46px;
          text-align: center;
          font-style: normal;
          text-transform: none;
          margin-top: 30px;
        }
      }
    }
  }
  .about5 {
    background: url("../../assets/m/about/aboutb2.png") no-repeat;
    background-size: cover;
    height: 1758px;
    .aboutbox {
      width: 750px;
      margin: 0 auto;
      padding-top: 80px;
      .tit {
        height: 55px;
        font-family: Poppins, Poppins;
        font-weight: 600;
        font-size: 32px;
        color: #1a1a2c;
        line-height: 54px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
      .tit1 {
        margin: 0 auto;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 28px;
        color: #61666b;
        line-height: 46px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin-top: 30px;
      }
      .box {
        width: 633px;
        height: 397px;
        background: #ffffff;
        border-radius: 10px 10px 10px 10px;
        margin: 0 auto;
        margin-top: 53px;
        .left {
          width: 12px;
          height: 12px;
          background: #4573e7;
          border-radius: 50%;
          margin-left: 81px;
          margin-right: 12px;
          margin-top: 65px;
        }
        .left1 {
          background: #e74545;
        }
        .right {
          display: flex;
          margin-left: 12px;
          .rtit {
            margin-top: 53px;
            // width: 452px;
            text-align: center;
            font-family: Poppins, Poppins;
            font-weight: 600;
            font-size: 27px;
            color: #1a1a2c;
            line-height: 40px;
            text-align: center;
            font-style: normal;
            text-transform: none;
            word-spacing: -1px;
          }
        }
        .rcon {
          width: 524px;
          margin: 0 auto;
          margin-top: 27px;

          font-family: Poppins, Poppins;
          font-weight: 500;
          font-size: 25px;
          color: #61666b;
          line-height: 46px;
          text-align: center;
        }
      }
      .box1 {
        height: 719px;
        margin-top: 53px;
      }
    }
  }
  .about6 {
    width: 750px;
    margin: 0 auto;

    margin-top: 140px;
    padding-bottom: 157px;
    .aboutl {
      .tit {
        width: 458px;
        margin: 0 auto;
        height: 109px;
        font-family: Poppins, Poppins;
        font-weight: 600;
        font-size: 32px;
        color: #1a1a2c;
        line-height: 54px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
      .tit1 {
        width: 569px;
        margin: 0 auto;
        height: 120px;
        font-family: Poppins, Poppins;
        font-weight: 600;
        font-size: 27px;
        color: #1a1a2c;
        line-height: 40px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
      .tit2 {
        width: 650px;
        height: 184px;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 28px;
        color: #61666b;
        line-height: 46px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin: 0 auto;
        margin-top: 40px;
      }
      .img8 {
        width: 248px;
        height: 255px;
        margin-top: 87px;
        margin-left: 251px;
      }
      .img9{
        width: 256px;
        height: 270px;
        margin-top: 106px;
        margin-left: 247px;
      }
    }
    .aboutr {
      img {
        width: 256px;
        height: 270px;
        margin-top: 105px;
        margin-left: 237px;
      }
      .tit {
        width: 650px;
        margin: 0 auto;
        height: 276px;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 28px;
        color: #61666b;
        line-height: 46px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
    }
  }
  .about7 {
    padding-bottom: 270px;
    .line {
      width: 650px;
      margin: 0 auto;
      height: 1px;
      background: #cccdd1;
      //border: 0.1px solid #cccdd1;
      // border-radius: 0px 0px 0px 0px;
      margin-bottom: 60px;
    }
    .linkbox {
      width: 650px;
      margin: 0 auto;
      display: flex;
      margin-bottom: 60px;
      .tit {
        width: 382px;
        height: 200px;
        font-family: Poppins, Poppins;
        font-weight: 600;
        font-size: 27px;
        color: #1a1a2c;
        line-height: 40px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-left: 40px;
        a{
          text-decoration: underline;
          color: #4573E7;
          cursor: pointer;
        }
        
      }
      img {
        width: 128px;
        height: 138px;
        margin-top: 29px;
        margin-left: 59px;
      }
    }
  }
}
</style>
